var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":"","middle":""}},[_c('van-loading',{attrs:{"size":"24px"}},[_vm._v("加载中...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }